module.exports = __webpack_public_path__ + "static/media/marco-ciotoli.3c25e23a.jpg";